<template>
	<div>

		<a-modal
		      :title="form.mendian_id > 0 ? '编辑门店' : '新增门店'"
		      :visible="visible"
		      :confirm-loading="confirmLoading"
		      @ok="handleOk"
		      @cancel="handleCancel"
			  :width="800"
		    >
		    <a-form-model :model="form">

		      	<a-form-model-item required label="门店名称">
		      		<a-input v-model="form.name" placeholder="输入门店名称" style="width: 300px;"></a-input>
		      	</a-form-model-item>

		      	<a-form-model-item required label="门店电话">
		      		<a-input v-model="form.tel" placeholder="输入门店电话" style="width: 300px;"></a-input>
		      	</a-form-model-item>

				<a-form-model-item required label="当天营业开始时间">
		      		
					<a-time-picker
						v-model="form.business_start"
						format="HH:mm"
						valueFormat="HH:mm"
						placeholder="当天营业开始时间"
						style="width: 100%"
					/>
		      	</a-form-model-item>

				<a-form-model-item required label="当天营业结束时间">
					<a-time-picker
						v-model="form.business_end"
						format="HH:mm"
						valueFormat="HH:mm"
						placeholder="当天营业结束时间"
						style="width: 100%"
					/>
		      	</a-form-model-item>

				<a-form-model-item required label="门店简介">
					<!-- <a-input v-model="form.info"  placeholder="输入门店简介" type="textarea"></a-input> -->
					<html-edit v-model="form.info"></html-edit>
				</a-form-model-item>
		      	
		      	<a-form-model-item required label="门店地址">
		      		<a-input v-model="form.address"  placeholder="输入门店地址" style="width: 300px;"></a-input>
		      	</a-form-model-item>

		      	<a-form-model-item required label="门店定位">
		      		<div class="flex alcenter">
		      			<a-input :value="form.lat + ',' + form.lng" disabled style="width: 200px; margin-right: 10px; color: #000000;"></a-input>
		      			<baidu-map :lat="form.lat" :lng="form.lng" @select="selectAct"></baidu-map>
		      		</div>
		      	</a-form-model-item>

				<a-form-model-item required label="门店logo">
					<div>
						<div class="ft12 cl-notice">建议上传200x200px</div>
						<div class="mt12">
							<upload-img v-model="form.logo"></upload-img>
						</div>
					</div>
				</a-form-model-item>

				<a-form-model-item label="门店门头照">
					<div>
						<!-- <div class="ft12 cl-notice">建议上传200x200px</div> -->
						<div class="mt12">
							<upload-img v-model="form.imgfm2"></upload-img>
						</div>
					</div>
				</a-form-model-item>
		      	
		    </a-form-model>	
		</a-modal>
	</div>
</template>

<script>
	import uploadImg from '../../../../components/upload/upload.vue';
	import BaiduMap from '../../../../components/map/baidumap.vue';
	import htmlEdit from '../../../../components/html.vue';
	export default {
		components:{
			uploadImg,
			BaiduMap,
			htmlEdit
		},
		props:{
			datas:{
				type:Object,
				default:function(){
					return new Object;
				}
			},
		},
		data(){
			return {
				confirmLoading:false,
				visible:true,
				form:{},
			}
		},
		created(){
			this.form = JSON.parse(JSON.stringify(this.datas));
			this.visible = true;
		},
		methods:{
			selectAct(res){
				this.form.lng = res.lng;
				this.form.lat = res.lat;
			},
			handleOk(){
				if(this.confirmLoading == true) return;
				this.confirmLoading = true;
				this.$http.api('admin/saveMendian',{
					mendian_id:this.form.mendian_id,
					name:this.form.name,
					tel	:this.form.tel,
					business_start	:this.form.business_start,
					business_end	:this.form.business_end,
					info	:this.form.info,
					address:this.form.address,
					lng:this.form.lng,
					lat:this.form.lat,
					logo	:this.form.logo,
					imgfm2	:this.form.imgfm2,
					
				}).then(res=>{
					this.$message.success('操作成功');
					this.confirmLoading = false;
					this.visible = false;
					this.$emit('ok');
				}).catch(res=>{
					this.confirmLoading=false;
				})
			},
			handleCancel(){
				this.visible = false;
				this.$emit('closed');
			}
		}
	}
</script>

<style>
	
</style>